import { getUsersRequest, isLoggedInRequest } from '../User/UserActions';
import { getConversationsRequest, getAllConversationsRequest } from '../Conversation/ConversationActions';
import { getPublicConfigRequest } from '../Config/ConfigActions';
import { initLanguage } from '../Intl/IntlActions';
import { addError } from '../Error/ErrorActions';

import config from '../../config';
import callApi from '../../util/apiCaller';
import { sequence } from '../../util/promises';
import {
    clearVersionReloadGuardIfMatched,
    hardReloadForStaleApp,
} from '../../util/staleCache';
import { getCurrencyRatesRequest, initCurrency } from '../Currency/CurrencyActions';
import { getAddressesRequest } from '../Address/AddressActions';
import { getOrdersByUserRequest, getOrdersRequest } from '../Order/OrderActions';
import { getProductsRequest } from '../Product/ProductActions';
import { getVatRatesRequest } from '../Vat/VatActions';

// Export Constants
export const SET_REDIRECT = 'SET_REDIRECT';
export const REDIRECT = 'REDIRECT';
export const SET_MOUNTED = 'SET_MOUNTED';
export const UPDATE_TABLE = 'UPDATE_TABLE';
export const INIT_PERSISTED_DATA = 'INIT_PERSISTED_DATA';
export const SET_IS_FETCHING = 'SET_IS_FETCHING';
export const SET_SSR_MODE = 'SET_SSR_MODE';
export const SET_REFERRAL = 'SET_REFERRAL';
export const SET_META_ATTRIBUTION = 'SET_META_ATTRIBUTION';

export const FETCH_LIMIT = 100;
export const REFERRAL_QUERY_PARAM = 'referral';
/**
 * Poll /api/app/web/version while the tab is visible.
 * Kept moderate (15 min) so Cloudflare / origin are not hammered; visibilitychange covers return-to-tab.
 */
export const APP_VERSION_CHECK_INTERVAL_MS = 15 * 60 * 1000; // 15 min

// Export Request Actions
export function initApp() {
    return dispatch => {
        console.log('initApp called');
        return dispatch(isLoggedInRequest()).then(user => {
            let initItems = [getPublicConfigRequest, getCurrencyRatesRequest, getVatRatesRequest, getProductsRequest];
            if(user) {
                initItems.push(getAddressesRequest, getOrdersByUserRequest);
                switch(user.role) {
                    case 'admin':
                        // initItems = initItems.concat([getUsersRequest, getAllConversationsRequest]);
                        break;

                    case 'customer':
                    default:
                        initItems = initItems.concat([getConversationsRequest]);
                        break;
                }
                // return dispatch(getConversationsRequest()).then(() => {
                    // if(userRole === 'admin') {
                    //     return dispatch(getUsersRequest());
                    // }
                // });
            } else {
                initItems.push(initLanguage);
            }
            return sequence(initItems, dispatch).then(results => {
                return dispatch(setMounted());
            });
        });
    };
}

export function checkVersionRequest() {
    return dispatch => callApi('app/web/version').then(res => {
        const serverVersion = res && res.version;
        if(serverVersion && process.env.NODE_ENV !== 'development') {
            clearVersionReloadGuardIfMatched(config.version, serverVersion);
            if(serverVersion !== config.version) {
                return hardReloadForStaleApp('version', serverVersion).then(() => serverVersion);
            }
        }
        return serverVersion;
    }).catch(error => {
        dispatch(addError(error));
    });
}

export function getLocalizationRequest() {
    return callApi('app/localization');
}

export function createIndexRequest() {
    return dispatch => callApi('app/database/index').then(res => {
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
        });
}

// Export Actions

export function getTable(store, tableId) {
    return store.app.tables.find(table => table.id === tableId) || {};
}

export function isFetching(store, type) {
    return (store[type] || {}).isFetching || false;
}

export function isCanonicalForced(store) {
    return store.app.forceCanonical;
}

export function setRedirect(redirect = '') {
    // console.log('setRedirect', redirect);
    return {
        type: SET_REDIRECT,
        redirect,
    };
}

export function redirect(redirect = null, replaceIfSet = false) {
    return {
        type: REDIRECT,
        redirect,
        replaceIfSet,
    };
}

export function setMounted() {
    return {
        type: SET_MOUNTED,
    };
}

export function updateTable(tableId, tableData) {
    return {
        type: UPDATE_TABLE,
        tableId,
        tableData,
    };
}

export function initPersistedData() {
    return {
        type: INIT_PERSISTED_DATA,
    };
}

export function setIsFetching(dataType, isFetching = true) {
    return {
        type: SET_IS_FETCHING,
        dataType: dataType.toLowerCase(),
        isFetching,
    };
}

export function setAppSSRMode(isSSR) {
    return {
        type: SET_SSR_MODE,
        isSSR,
    };
}

export function setReferral(referral) {
    return {
        type: SET_REFERRAL,
        referral,
    };
}

export function getReferral(store) {
    return store.app.referral;
}

export function setMetaAttribution(metaAttribution) {
    return {
        type: SET_META_ATTRIBUTION,
        metaAttribution,
    };
}

export function getMetaAttribution(store) {
    return store.app.metaAttribution || null;
}
